import * as React from 'react';
import {
  ComboBox,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent
} from '@progress/kendo-react-dropdowns';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';

const allData = [
  { text: 'Small', value: 'sm' },
  { text: 'Medium', value: 'md' },
  { text: 'Large', value: 'lg' }
];

export const IconScaleCombobox: React.FC<{
  value: 'sm' | 'md' | 'lg';
  onChange: (event: ComboBoxChangeEvent) => void;
}> = ({ value, onChange }) => {
  const [data, setData] = React.useState(allData.slice());

  const filterData = (filter: FilterDescriptor) => {
    const data = allData.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event: ComboBoxFilterChangeEvent) => {
    setData(filterData(event.filter));
  };

  return (
    <ComboBox
      data={data}
      textField="text"
      filterable={true}
      value={{
        text: allData.find((d) => d.value === value)?.text,
        value
      }}
      onChange={onChange}
      onFilterChange={filterChange}
      placeholder="Please select ..."
    />
  );
};
